<template>
  <div>
    <v-app-bar
      dark
      color="white"
      flat
      fixed
      elevation="3"
      :hide-on-scroll="false"
    >
    <!-- :hide-on-scroll="$store.state.mode !== 'ats' && $store.state.mode !== 'atsDev'" -->
    <!-- :fixed="$store.state.mode !== 'ats' && $store.state.mode !== 'atsDev' && ($route.name === 'Home' || $route.name === 'flights' || $route.name === 'hotels' || $route.name === 'cars' || $route.name === 'carBook')" -->
      <v-container :fluid="($store.state.mode === 'adam' || $store.state.mode === 'adamDev') && $vuetify.breakpoint.mdAndDown">
        <v-row>
            <v-btn icon @click="drawer = !drawer" class="d-flex d-md-none mt-3"
            v-if="($store.state.mode !== 'ats' && $store.state.mode !== 'atsDev') ||
            (($store.state.mode === 'ats' || $store.state.mode === 'atsDev') && $cookies.isKey('userToken'))"
            >
              <v-icon large color="secondary">mdi-menu</v-icon>
            </v-btn>
            <v-col cols="2" class="pt-3">
              <router-link v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adam' && $store.state.mode !== 'adamDev'" style="text-decoration: none;" to="/">
                <v-img src="../static/logo.png" class="mt-2" alt="fare33 logo" min-width="90" max-width="110"></v-img>
              </router-link>
              <a v-if="$store.state.mode === 'ats' || $store.state.mode === 'atsDev'" style="text-decoration: none;" href="https://atsfares.com/"><v-img src="../static/logo-dark.png" class="mt-2" alt="fare33 logo" min-width="90" max-width="110"></v-img></a>
              <a v-if="$store.state.mode === 'adamt' || $store.state.mode === 'adamDev'" style="text-decoration: none;" href="https://adamtravel.com/"><v-img src="../static/logo-adam.png" class="mt-3" alt="fare33 logo" min-width="110" max-width="130"></v-img></a>
            </v-col>
            <div class="d-flex"
            v-if="($store.state.mode !== 'ats' && $store.state.mode !== 'atsDev') || (($store.state.mode === 'ats' || $store.state.mode === 'atsDev') && $cookies.isKey('userToken'))"
            >
              <v-btn v-for="tab in tabs" :key="tab.title" exact :to="{ name: tab.route} " :text="$route.name !== tab.title" elevation="0" :tile="$route.name == tab.title" :color="$route.name == tab.title ? 'secondary' : 'secondary'" height="53" :large="$vuetify.breakpoint.lgAndUp" class="d-none d-md-flex mt-3" >
                  <v-icon small v-if="$store.state.mode !== 'adam' && $store.state.mode !== 'adamDev'">{{tab.icon}}</v-icon>
                  <span class="body-2">{{tab.title}}</span>
              </v-btn>
            </div>
            <v-btn v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adam' && $store.state.mode !== 'adamDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('about')" height="53" elevation="0" :text="$route.name !== 'about'" :tile="$route.name == 'about'" :large="$vuetify.breakpoint.lgAndUp"><span class="body-2">About us</span></v-btn>
            <v-btn v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adam' && $store.state.mode !== 'adamDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('rewards')" height="53" elevation="0" :text="$route.name !== 'rewards'" :tile="$route.name == 'rewards'" :large="$vuetify.breakpoint.lgAndUp"><v-icon small class="bell">mdi-wallet-giftcard</v-icon><span class="body-2">Rewards</span></v-btn>

            <v-menu offset-y open-on-hover transition="slide-x-transition" v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  height="53"
                  class="d-none d-md-flex mt-3"
                  :large="$vuetify.breakpoint.lgAndUp"
                  v-bind="attrs"
                  v-on="on"
                  text
                >
                  <span class="body-2">UMRAH</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('umrah-pre')" text><span class="body-2">Umrah 2021 pre registeration</span></v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('umrah')" text><span class="body-2">Umrah 2021</span></v-btn>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y open-on-hover transition="slide-x-transition" v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  height="53"
                  class="d-none d-md-flex mt-3"
                  :large="$vuetify.breakpoint.lgAndUp"
                  v-bind="attrs"
                  v-on="on"
                  text
                >
                  <span class="body-2">Hajj</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('hajj-pre')" text><span class="body-2">hajj 2021 pre registeration</span></v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('hajj')" text><span class="body-2">hajj 2021</span></v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('hajj-blog')" text><span class="body-2">hajj blog</span></v-btn>
                </v-list-item>
                <v-list-item>
                  <v-btn class="d-none d-md-flex mt-3" color="secondary" @click="goTo('hajj-resources')" text><span class="body-2">hajj resources</span></v-btn>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('offices')" height="53" elevation="0" text :large="$vuetify.breakpoint.lgAndUp"><span class="body-2">Offices</span></v-btn>
            <v-btn v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('about-adam')" height="53" elevation="0" text :large="$vuetify.breakpoint.lgAndUp"><span class="body-2">About us</span></v-btn>
            <v-btn v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('contact-adam')" height="53" elevation="0" text :large="$vuetify.breakpoint.lgAndUp"><span class="body-2">Contact</span></v-btn>

            <v-btn v-if="$store.state.mode === 'ats' || $store.state.mode === 'atsDev'" class="d-none d-md-flex mt-3" color="secondary" @click="goTo('commissions')" height="53" elevation="0" text :large="$vuetify.breakpoint.lgAndUp"><span class="body-2">Comissions</span></v-btn>
            <v-spacer></v-spacer>
            <router-link style="text-decoration: none;" :to="{ name: 'login'} " v-if="!$cookies.isKey('userToken')">
              <v-btn text :large="$vuetify.breakpoint.lgAndUp" :small="$vuetify.breakpoint.mdAndDown" color="secondary" class="mt-3" height="53">
                  <v-icon left>mdi-account-circle</v-icon>
                  <span>Login</span>
              </v-btn>
            </router-link>

            <v-menu offset-y v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="white --text"
                  text
                  v-on="on"
                  class="mt-5"
                >
                  <!-- <v-badge
                    bordered
                    color="error"
                    icon="mdi-email"
                    overlap
                    left
                    light
                    :value="$store.state.newMail"
                  > -->
                    <v-avatar color="secondary" class="mr-2" size="32">
                      <span class="white--text body-1">
                        {{user.name.charAt(0).toUpperCase()}}
                      </span>
                    </v-avatar>
                  <!-- </v-badge> -->
                  <span class="d-none d-sm-flex secondary--text">{{user.name.substr(0, user.name.indexOf(' '))}}</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link exact :to="{ name: 'profile' }">
                  <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item link exact :to="{ name: 'mail' }">
                  <v-list-item-icon><v-icon>mdi-email</v-icon></v-list-item-icon>
                  <v-list-item-title>Notifications</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="logout">
                  <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

        </v-row>
      </v-container>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      color="white"
      dark
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="secondary--text text-accent-4"
        >
          <v-list-item two-line link exact :to="{ name: 'login' }" v-if="!$cookies.isKey('userToken')">
            <v-list-item-avatar>
              <v-icon color="secondary">mdi-account-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="secondary--text">Login / Register</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line link exact :to="{ name: 'profile' }" v-else>
            <v-list-item-avatar v-if="user !== null">
              <v-avatar color="secondary" class="text-center" size="32">

                  <span class="white--text body-1">
                    {{user.name.charAt(0).toUpperCase()}}
                  </span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>

              <v-list-item-title v-cloak class="secondary--text">{{user.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev'" link exact to="/">
            <v-img src="http://dev-booking-engine.fare33.com/images/assets/newlogo.png" alt="fare33 logo" max-width="50px"></v-img>
          </v-list-item>
          <v-list-item v-if="$store.state.mode === 'ats' || $store.state.mode !== 'atsDev'">
            <a style="text-decoration: none;" href="https://atsfares.com/">
              <v-img src="../static/logo-dark.png" alt="ats logo" max-width="50px"></v-img>
            </a>
          </v-list-item>
          <v-list-item v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
            <a style="text-decoration: none;" href="https://adamtravel.com/">
              <v-img src="../static/logo-adam.png" alt="adam logo" max-width="50px"></v-img>
            </a>
          </v-list-item>
          <v-list-item :active-class="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev' ? 'active-route' : 'active-route-blue'" link exact :to="{ name: item.route }" v-for="item in tabs" :key="item.title">
              <v-list-item-title :class="$route.name === item.title ? 'white--text' : 'secondary--text'">
                <v-icon small :color="$route.name === item.title ? 'white' : 'secondary'">{{item.icon}}</v-icon>
                {{item.title}}
              </v-list-item-title>
          </v-list-item>
          <v-list-item
          :active-class="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev' ? 'active-route' : 'active-route-blue'"
          v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev'"
          >
            <v-btn @click="goTo('about')" text x-small color="secondary">About us</v-btn>
          </v-list-item>
          <v-list-item
          :active-class="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev' ? 'active-route' : 'active-route-blue'"
          v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev'"
          @click="goTo('rewards')"
          >
            <v-btn text x-small color="secondary">Rewards</v-btn>
          </v-list-item>
          <v-list-item v-if="$store.state.mode === 'ats' || $store.state.mode === 'atsDev'">
            <v-btn @click="goTo('commissions')" text x-small color="secondary">Commissions</v-btn>
          </v-list-item>
          <v-list-group
          v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'"
          class="secondary--text"
          :value="true"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="secondary--text">Hajj</v-list-item-title>
              </v-list-item-content>
            </template>

              <v-list-item>
                <v-btn @click="goTo('hajj-pre')" text x-small color="secondary">hajj 2021 pre registeration</v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn @click="goTo('hajj')" text x-small color="secondary">hajj 2021</v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn @click="goTo('hajj-blog')" text x-small color="secondary">hajj blog</v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn @click="goTo('hajj-resources')" text x-small color="secondary">hajj resources</v-btn>
              </v-list-item>
          </v-list-group>
          <v-list-group
          v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'"
          :value="true"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="secondary--text">Umrah</v-list-item-title>
              </v-list-item-content>
            </template>

              <v-list-item>
                <v-btn @click="goTo('umrah-pre')" text x-small color="secondary">umrah 2021 pre registeration</v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn @click="goTo('umrah')" text x-small color="secondary">umrah 2021</v-btn>
              </v-list-item>
          </v-list-group>
          <v-list-item v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
            <v-btn @click="goTo('offices')" class="mr-5" text small color="secondary">Offices</v-btn>
          </v-list-item>
          <v-list-item v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
            <v-btn @click="goTo('about-adam')" text small color="secondary">About Us</v-btn>
          </v-list-item>
          <v-list-item v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'">
            <v-btn @click="goTo('contact-adam')" text small color="secondary">Contact</v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { logout, headers } from '../links'
export default {
  data () {
    return {
      drawer: false,
      group: null,
      tabs: [
        { title: 'flights', route: 'flights', icon: 'mdi-airplane' },
        { title: 'hotels', route: 'hotels', icon: 'mdi-domain' },
        { title: 'cars', route: 'cars', icon: 'mdi-car' }
      ],
      user: null
    }
  },
  computed: {
    userStore () {
      return this.$store.state.user
    }
  },
  watch: {
    userStore (newVal) {
      this.user = newVal
    },
    group () {
      this.drawer = false
    }
  },
  methods: {
    goTo (link) {
      let baseUrl
      switch (link) {
        case 'commissions':
          baseUrl = process.env.NODE_ENV === 'production' ? 'https://atsfares.com/commissions/index.php' : 'https://test.atsfares.com/commissions/index.php'
          window.open(baseUrl, '_blank')
          break
        case 'about-adam':
          baseUrl = 'https://adamtravel.com/about-adam-travel/'
          window.open(baseUrl, '_blank')
          break
        case 'contact-adam':
          baseUrl = 'https://adamtravel.com/contact/'
          window.open(baseUrl, '_blank')
          break
        case 'offices':
          baseUrl = 'https://adamtravel.com/offices/'
          window.open(baseUrl, '_blank')
          break
        case 'umrah-pre':
          baseUrl = 'https://adamtravel.com/umrah-registration/'
          window.open(baseUrl, '_blank')
          break
        case 'umrah':
          baseUrl = 'https://adamtravel.com/package_cat/umrah2021/'
          window.open(baseUrl, '_blank')
          break
        case 'hajj-pre':
          baseUrl = 'https://adamtravel.com/hajj-2021/'
          window.open(baseUrl, '_blank')
          break
        case 'hajj':
          baseUrl = 'https://adamtravel.com/hajj-2/'
          window.open(baseUrl, '_blank')
          break
        case 'hajj-blog':
          baseUrl = 'https://adamtravel.com/hajj-blog/'
          window.open(baseUrl, '_blank')
          break
        case 'hajj-resources':
          baseUrl = 'http://hajjresources.adamtravel.com/'
          window.open(baseUrl, '_blank')
          break
        default:
          this.$router.push({ name: link })
          break
      }
    },
    logout () {
      this.$http.post(logout, null, { headers: headers(this.$cookies.get('userToken')) }).then(() => {
        this.$store.dispatch('removeUser')
        this.$cookies.remove('userToken')
        localStorage.removeItem('userId')
        localStorage.removeItem('token')
        this.$router.push({ name: 'login' })
      })
    }
  },
  created () {
    this.user = this.$store.state.user
    if (this.$store.state.mode !== 'ats' && this.$store.state.mode !== 'atsDev') this.tabs.push({ title: 'trips', route: 'trips', icon: 'mdi-beach' })
  }
}
</script>

<style>
  [v-cloak] { display: none; }
  .active-route {
    background-color: #E28134;
    border-radius: 5PX;
    height: 58px;
  }
  .active-route-blue {
    background-color: #150958;
    border-radius: 5PX;
    height: 58px;
  }
  .bell{
    -webkit-animation: ring 4s .7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ring 4s .7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ring 4s .7s ease-in-out infinite;
    transform-origin: 50% 4px;
  }
  @keyframes ring {
    0% { transform: rotate(0); }
    1% { transform: rotate(30deg); }
    3% { transform: rotate(-28deg); }
    5% { transform: rotate(34deg); }
    7% { transform: rotate(-32deg); }
    9% { transform: rotate(30deg); }
    11% { transform: rotate(-28deg); }
    13% { transform: rotate(26deg); }
    15% { transform: rotate(-24deg); }
    17% { transform: rotate(22deg); }
    19% { transform: rotate(-20deg); }
    21% { transform: rotate(18deg); }
    23% { transform: rotate(-16deg); }
    25% { transform: rotate(14deg); }
    27% { transform: rotate(-12deg); }
    29% { transform: rotate(10deg); }
    31% { transform: rotate(-8deg); }
    33% { transform: rotate(6deg); }
    35% { transform: rotate(-4deg); }
    37% { transform: rotate(2deg); }
    39% { transform: rotate(-1deg); }
    41% { transform: rotate(1deg); }

    43% { transform: rotate(0); }
    100% { transform: rotate(0); }
  }
</style>
